import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  set(key: string, value: any) {
    sessionStorage.setItem(key, value !== undefined ? JSON.stringify(value) : null);
  }

  private isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  get(key: string) {
    const itemStr = sessionStorage.getItem(key);
    if (itemStr === undefined) return null;

    const parsedValue = this.isJSON(itemStr) ? JSON.parse(itemStr) : itemStr;

    if (!parsedValue) return parsedValue;

    return this.isJSON(parsedValue) ? JSON.parse(parsedValue) : parsedValue;
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}
